<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import LoadSpinner from './load-spinner.svelte'
    import Fa from 'svelte-fa'
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    let dispatch = createEventDispatcher()

    export let disabled: boolean = false
    export let base64: string = ''
    export let upload: boolean = false
    export let inline: boolean = false
    export let label: string = ''
    export let accept: string = '.png,.jpg,.jpeg,.heic'
    export let type: 'image' | 'file' = 'image'
    export let presign: boolean = false
    export let folderName: string = 'front-upload'
    /** Reduz a imagem para caber nestes limites (mantendo a proporção) antes de subir. Zero desliga
     * a redução — é o padrão, para não mudar o comportamento de quem já usa o componente. */
    export let maxWidth: number = 0
    export let maxHeight: number = 0

    let fileName: string = ''
    let extension: string = ''

    let image
    let file

    function onFileChanged() {
        base64 = ''
        fileName = ''
        if (!file.files || !file.files[0]) {
            return
        }
        let filePath = file.files[0]
        fileName = filePath?.name || ''
        extension = window.api.events.files.getExtension(fileName)
        let reader = new FileReader()
        reader.readAsDataURL(filePath)
        let reload = false
        reader.onload = (e) => {
            let content: string = reader.result as string
            base64 = content
            evaluateNewFile()
        }
    }

    let show = false
    async function evaluateNewFile() {
        if (extension.toLowerCase() === 'heic') {
            try {
                show = true
                let result = await window.api.utils.images.convertHeicBase64ToJpg(base64)
                base64 = result
                extension = 'jpg'
            } catch (error) {
                window.error(error)
            } finally {
                show = false
            }
        }
        // Depois da conversão de HEIC (que já normalizou para JPG) e antes do upload: o que sobe é
        // o que fica guardado e o que todo mundo vai decodificar depois.
        if (type === 'image' && maxWidth && maxHeight) {
            try {
                show = true
                base64 = await window.api.utils.images.resizeBase64(base64, maxWidth, maxHeight)
            } catch (error) {
                window.error(error)
            } finally {
                show = false
            }
        }
        if (upload) {
            try {
                show = true
                let result
                if (presign) {
                    result = await window.api.events.files.uploadToSignedLink({ content: base64, extension, folderName })
                } else {
                    result = await window.api.events.files.upload({ content: base64, folderName })
                }
                base64 = result.url
            } catch (error) {
                window.error(error)
            } finally {
                show = false
            }
        }
        dispatch('change', { base64: base64 })
    }

    export function click() {
        onImageClick()
    }

    function onImageClick() {
        if (disabled) return
        file.click()
    }

    $: {
        if (image) image.src = base64
    }
    $: {
        if (!base64 && image) image.src = ''
    }

    function generateFilename(_base64) {
        if (_base64 && !fileName) fileName = '[arquivo carregado]'
    }

    $: {
        generateFilename(base64)
    }

    onMount(() => {
        //generateFilename(base64, fileName)
    })

    function onImageClear() {
        base64 = ''
        dispatch('change', { base64: '' })
        file.value = null
        fileName = ''
    }

    function onAbort() {
        console.log('aborted')
        dispatch('cancel')
    }
</script>

<LoadSpinner delay={0} {show}></LoadSpinner>

<input type="file" {accept} bind:this={file} on:change={onFileChanged} on:cancel={onAbort} style="position:absolute;top:-30000px;max-width:50px;" />

{#if inline}
    <div class="input-group zimage-upload">
        {#if label}
            <label for="" class="input-group-text">{label}</label>
        {/if}
        {#if type === 'image'}
            <div class="input-group-text inline-image-outer" on:click={onImageClick}>
                <img bind:this={image} src="" alt="" class="inline-image" class:inline-hide-image={!base64} />
                <img src="/img/no-image.jpg" alt="" class="inline-no-image" class:inline-hide-image={!!base64} />
            </div>
        {/if}
        <label for="" class="form-control file-name nowrap" on:click={onImageClick}>
            <div>{fileName}</div>
            <div on:click|stopPropagation={onImageClear} class="file-name_clear"><Fa icon={faTimes}></Fa></div>
        </label>
    </div>
{:else}
    {#if label}
        <div class="boxed-image_label">{label}</div>
    {/if}
    <img class:disabled class:inline on:click={onImageClick} class="boxed-image" bind:this={image} src="" alt="" />
{/if}

<style>
    .boxed-image {
        min-height: 50px;
        min-width: 100%;
        max-width: 100%;
        cursor: pointer;
    }
    .boxed-image[src=''] {
        border: 2px dashed #66666650;
    }
    .disabled {
        cursor: default;
    }

    .inline-image-outer {
        overflow: hidden;
        width: 40px;
        height: 39px;
        padding: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 0px;
        cursor: pointer;
    }
    .inline-image {
        width: 40px;
    }
    .file-name {
        cursor: pointer;
    }

    .inline-hide-image {
        display: none;
    }

    .inline-no-image {
        background: url('/img/no-image.jpg') no-repeat center center;
        background-size: contain;
        height: 100%;
    }
</style>
